import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import { useMutation } from '@apollo/react-hooks';
import { injectIntl } from 'react-intl';
import { CREATE_LOCAL_ARI } from '../mutations';
import { withAccount } from '../../../../components/AccountContext';
import LocalFieldList from './LocalFieldList';
import CreateTextField from './CreateTextField';
import CreateNumberField from './CreateNumberField';
import CreateDropdownField from './CreateDropdownField';
import messages from '../intl-messages';


const CreateLocalARIFields = ({
  maxFieldCount, currentFieldCount, currentAccount, ariTypeOptions, data, intl: { formatMessage },
}) => {
  const [ariType, setAriType] = useState('');

  const [addLocalAriField] = useMutation(CREATE_LOCAL_ARI, { refetchQueries: ['getAccount'] });

  return (
    <div style={{ marginBottom: '10px', width: '100%' }}>
      <Panel
        className="p-col-12 sub-panel"
        header={`${formatMessage(messages.localCreatePanelHeader)} (${currentFieldCount}/${maxFieldCount})`}
      >
        <div style={{ marginBottom: '10px' }}>
          <LocalFieldList data={data} />
        </div>

        {currentFieldCount < maxFieldCount
          && (
            <div style={{ padding: '10px', border: '1px solid black' }}>
              <small>
                {formatMessage(messages.newQuestionType)}
              </small>
              <div className="p-grid">
                <div className="p-col-12">
                  <Dropdown
                    value={ariType}
                    options={ariTypeOptions}
                    onChange={e => setAriType(e.target.value)}
                    placeholder={formatMessage(messages.dropdownPlaceholder)}
                  />
                </div>
                {ariType === 'TEXT'
                  && (
                    <CreateTextField
                      addLocalAriField={addLocalAriField}
                      currentAccount={currentAccount}
                    />
                  )}
                {ariType === 'NUMBER'
                  && (
                    <CreateNumberField
                      addLocalAriField={addLocalAriField}
                      currentAccount={currentAccount}
                    />
                  )
                }
                {ariType === 'DROPDOWN'
                  && (
                    <CreateDropdownField
                      addLocalAriField={addLocalAriField}
                      currentAccount={currentAccount}
                    />
                  )}
              </div>
            </div>
          )}
      </Panel>
    </div>
  );
};

CreateLocalARIFields.propTypes = {
  ariTypeOptions: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  currentAccount: PropTypes.string.isRequired,
  currentFieldCount: PropTypes.number.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  maxFieldCount: PropTypes.number.isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withAccount(injectIntl(CreateLocalARIFields));
